module.exports = __webpack_public_path__ + "static/media/adjudication.c4b50e92.pdf";